module.exports = __webpack_public_path__ + "static/d5Res1-4e8319b1af3ec4a14cf75099792e5be2.png";